import { render, staticRenderFns } from "./basicCategory.vue?vue&type=template&id=7d0e7f04&"
import script from "./basicCategory.vue?vue&type=script&lang=js&"
export * from "./basicCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports